import type { LinkProps } from '@property.com.au/ui-kit';

export type ApiLinkVariant =
  | 'BUTTON_PRIMARY'
  | 'BUTTON_SECONDARY'
  | 'BUTTON_SHADOW'
  | 'INLINE'
  | 'NAKED'
  | 'OUTLINE'
  | 'OUTLINE_SECONDARY'
  | 'PRIMARY'
  | 'SECONDARY';

export const mapApiWeblinkVariantToLinkVariant = (
  variant: ApiLinkVariant,
): LinkProps['variant'] => {
  switch (variant) {
    case 'PRIMARY':
      return 'primary';
    case 'SECONDARY':
      return 'secondary';
    case 'BUTTON_PRIMARY':
      return 'button-primary';
    case 'BUTTON_SECONDARY':
      return 'button-secondary';
    case 'OUTLINE':
      return 'button-outline';
    case 'OUTLINE_SECONDARY':
      return 'button-outline-secondary';
    case 'NAKED':
      return 'button-naked';
    case 'BUTTON_SHADOW':
      return 'button-shadow';
    default:
      return 'button-primary';
  }
};
